import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "post" };
import { ref, reactive } from "vue";
import imgUpload from "@/components/Upload.vue";
import { ElMessage } from "element-plus";
import { updateCooperationInfo } from "@/api/cooperation";
export default /*@__PURE__*/ _defineComponent({
    __name: 'post',
    emits: ["saved"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const dialogVisible = ref(false);
        const title = ref("修改商务信息");
        const qrImgUrl = ref([]);
        const qrImgIds = ref([]);
        const form = reactive({
            contactPhone: "",
            contactEmail: "",
            companyPhone: "",
            companyWebsite: "",
        });
        const onUpload = (val) => {
            qrImgUrl.value = val.pictureUrls;
            qrImgIds.value = val.pictureIds;
        };
        const show = (data) => {
            form.contactPhone = data?.contactPhone || "";
            form.contactEmail = data?.contactEmail || "";
            form.companyPhone = data?.companyPhone || "";
            form.companyWebsite = data?.companyWebsite || "";
            qrImgUrl.value = data?.qrCode ? [data.qrCode] : [];
            qrImgIds.value = [];
            dialogVisible.value = true;
        };
        const handleConfirm = async () => {
            try {
                await updateCooperationInfo({
                    id: "1",
                    contactPhone: form.contactPhone,
                    contactEmail: form.contactEmail,
                    companyPhone: form.companyPhone,
                    companyWebsite: form.companyWebsite,
                    qrCode: qrImgUrl.value[0] || "",
                });
                ElMessage.success("保存成功");
                dialogVisible.value = false;
                emit("saved");
            }
            catch {
                ElMessage.error("保存失败");
            }
        };
        __expose({ show });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_dialog, {
                    modelValue: dialogVisible.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((dialogVisible).value = $event)),
                    title: title.value,
                    "close-on-click-modal": false,
                    center: "",
                    style: { "width": "25%" }
                }, {
                    footer: _withCtx(() => [
                        _createVNode(_component_el_button, {
                            onClick: _cache[5] || (_cache[5] = ($event) => (dialogVisible.value = false))
                        }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                    _createTextVNode("取消", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: handleConfirm
                        }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createTextVNode("确认", -1)
                                ]))]),
                            _: 1
                        })
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                            model: form,
                            ref: "formRef",
                            "label-width": "auto",
                            size: "default"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_form_item, { label: "联系电话：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.contactPhone,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.contactPhone) = $event)),
                                            placeholder: "请填写联系电话"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "联系邮箱：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.contactEmail,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.contactEmail) = $event)),
                                            placeholder: "请填写联系邮箱"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "公司电话：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.companyPhone,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.companyPhone) = $event)),
                                            placeholder: "请填写公司电话"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "公司网站：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                            modelValue: form.companyWebsite,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.companyWebsite) = $event)),
                                            placeholder: "请填写公司网站"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "二维码：" }, {
                                    default: _withCtx(() => [
                                        _createVNode(imgUpload, {
                                            imgUrl: qrImgUrl.value,
                                            imgIds: qrImgIds.value,
                                            onUploader: _cache[4] || (_cache[4] = (v) => onUpload(v))
                                        }, null, 8, ["imgUrl", "imgIds"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["model"])
                    ]),
                    _: 1
                }, 8, ["modelValue", "title"])
            ]));
        };
    }
});
